import styled from "styled-components";

const Container = styled("div")`
    width: 100vw;
    height: 180px;
    background-color: #55beca;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;

`
const Titulo = styled("h1")`
    margin: 0;
    white-space: nowrap;
    font-family: 'Artifika', serif;
    font-size: 70px;
    
`


const Navbar = () => {
    return (
        <Container>
            <Titulo>
                Club de Inversionista$
            </Titulo>
            
        </Container>
    )
}

export default Navbar